<ng-container *transloco="let t">
  <div
    *ngIf="isFacade(); else showRealButton"
    class="support-chat"
    tooltip="{{ tooltipText }}"
    placement="bottom"
  >
    <button
      class="btn btn-lg btn-icon-only btn-outline-secondary bg-transparent border-0"
      [attr.aria-label]="t('components.supportChat.ariaLabel')"
      (mouseover)="initFreshchat()"
      (click)="removeFacade()"
    >
      <i class="modus-icons text-white notranslate" aria-hidden="true" icon
        >chat</i
      >
    </button>
  </div>

  <ng-template #showRealButton>
    <div class="support-chat" tooltip="{{ tooltipText }}" placement="bottom">
      <button
        class="btn btn-lg btn-icon-only btn-outline-secondary bg-transparent border-0"
        [attr.aria-label]="t('components.supportChat.ariaLabel')"
        [disabled]="disabled()"
        (click)="toggleShowChat()"
      >
        <i class="modus-icons text-white notranslate" aria-hidden="true" icon
          >chat</i
        >
      </button>
    </div>
  </ng-template>
</ng-container>
